<template>
  <el-row :gutter="12" style="height: 100%; margin: 0px; padding: 5px 5px">
    <el-col style="height: 100%">
      <el-container style="height: 100%; overflow-y: hidden" class="form-div">
        <el-header
          height="40"
          style="
            padding: 10px 0px;
            display: flex;
            justify-content: start;
            flex-direction: row;
            text-align: start;
          "
          class="round-top"
        >
          <span style="margin-left: 15px; font-weight: 500; font-size: 20px">
            <i class="el-icon-date"></i>
            Histórico de Comunicações
          </span>
        </el-header>

        <el-main
          class="full-height;"
          style="padding: 10px 0px 10px 0px; background-color: white"
        >
          <el-row class="full-height">
            <el-col
              :md="24"
              :lg="8"
              :xl="8"
              style="height: 100%; border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <el-form size="small" label-position="top">
                <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item>
                      <span slot="label"> Tipo de Comunicação </span>
                      <el-select
                        v-model="cobranca.tipo"
                        value-key="id"
                        filterable
                        default-first-option
                        size="small"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in tiposComunicacao"
                          :key="item.id"
                          :label="item.label"
                          :value="item.data"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>


                <el-row :gutter="24">
                  <el-col :span="24" v-if="exibirCampoCliente">
                    <el-form-item>
                      <span slot="label"> Cliente </span>
                      <el-select
                        v-model="cobranca.cliente"
                        :remote-method="filtrarClientesSelect"
                        :loading="loadingClientes"
                        value-key="id"
                        placeholder=""
                        loading-text="Carregando clientes"
                        no-data-text="Nenhum cliente encontrado"
                        clearable
                        @clear="cobranca.cliente = undefined"
                        filterable
                        remote
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in clientesDisponiveis"
                          :key="item.id"
                          :label="`(${item.idNaImobiliaria}) ${item.nome} - ${
                            item.cpfCnpj ? item.cpfCnpj : '000.000.000-00'
                          }`"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" v-if="exibirCampoEmail">
                    <el-form-item>
                      <span slot="label"> Email </span>
                      <el-input
                        v-model="cobranca.email"
                        size="small"
                        clearable
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24" v-if="exibirCampoContrato">
                    <el-form-item>
                      <span slot="label"> Contrato </span>
                      <el-select
                        v-model="cobranca.contrato"
                        :remote-method="filtrarAluguelSelect"
                        :loading="loadingAluguel"
                        value-key="id"
                        placeholder=""
                        loading-text="Carregando Contratos"
                        no-data-text="Nenhum contrato encontrado"
                        filterable
                        clearable
                        @clear="cobranca.contrato = undefined"
                        remote
                        reserve-keyword
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in alugueisDisponiveis"
                          :key="item.id"
                          :label="`${item.idNaImobiliaria} - ${item.imovel.endereco} (${item.imovel.bairro.nome})`"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="12" v-if="exibirca">
                    <el-form-item>
                      <span slot="label"> Tipo Cobrança </span>
                      <el-select
                        v-model="cobranca.tipo"
                        value-key="id"
                        placeholder
                        filterable
                        clearable
                        default-first-option
                        @clear="cobranca.tipo = undefined"
                        size="small"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in tiposCobrancas"
                          :key="item.id"
                          :label="item.label"
                          :value="item.data"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item v-if="tipoCobrancaAutoIsVisible">
                      <span slot="label"> Tipo Cobrança Automática </span>
                      <el-select
                        v-model="cobranca.tipoCobrancaAuto"
                        value-key="id"
                        placeholder
                        filterable
                        default-first-option
                        clearable
                        @clear="cobranca.tipoCobrancaAuto = undefined"
                        size="small"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in tipoCobrancaAuto"
                          :key="item.id"
                          :label="item.label"
                          :value="item.data"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col> -->
                  </el-row>
                  <el-row :gutter="24">
                    <el-col :span="12" v-if="exibirCampoVencimento">
                      <el-form-item>
                        <span slot="label"> Vencimento </span>
                        <el-date-picker
                          auto-complete="off"
                          v-model="cobranca.recibo.dataVencimento"
                          v-mask="'##/##/####'"
                          type="date"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          style="width: 100%"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="exibirCampoDataRepasse">
                      <el-form-item>
                        <span slot="label"> Data Repasse </span>
                        <el-date-picker
                          auto-complete="off"
                          v-model="cobranca.recibo.dataVencimento"
                          v-mask="'##/##/####'"
                          type="date"
                          format="dd/MM/yyyy"
                          value-format="dd/MM/yyyy"
                          style="width: 100%"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="exibirCampoMesSerie">
                      <el-form-item>
                        <span slot="label"> Mês série </span>
                        <el-input
                          v-model="mesSerie"
                          v-mask="'####'"
                          size="small"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item>
                      <span slot="label"> Data/Hora Inicial </span>
                      <el-date-picker
                        v-model="cobranca.dataHoraInicial"
                        v-mask="'##/##/#### ##:##'"
                        value-format="dd/MM/yyyy HH:mm"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <span slot="label"> Data/Hora Final </span>
                      <el-date-picker
                        v-model="cobranca.dataHoraFinal"
                        v-mask="'##/##/#### ##:##'"
                        value-format="dd/MM/yyyy HH:mm"
                        type="datetime"
                        format="dd/MM/yyyy HH:mm"
                        style="width: 100%"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label=" ">
                      <el-button
                        @click="pesquisa()"
                        size="small"
                        type="success"
                        style="width: 100%"
                        round
                        class="btn-box-shadow"
                      >
                        <i class="el-icon-search"></i>
                        Pesquisar
                      </el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label=" ">
                      <el-button
                        @click="limparPesquisa"
                        size="small"
                        type="warning"
                        style="width: 100%"
                        round
                        class="btn-box-shadow"
                      >
                        <i class="el-icon-s-open"></i>
                        Limpar
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="24"
                  style="
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                    margin-top: 1em;
                  "
                >
                  <el-col :span="12">
                    <el-form-item label=" ">
                      <el-button
                        @click="gerarRelatorio"
                        type="primary"
                        size="small"
                        round
                        style="width: 100%"
                        class="btn-box-shadow"
                      >
                        <i class="el-icon-document"></i> Gerar
                        Relatório</el-button
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-show="exibirOrdenacao">
                    <el-form-item label=" ">
                      <el-button
                        @click="filtrarListaCobrancas()"
                        size="small"
                        round
                        style="width: 100%"
                        v-if="listaCobrancas.length > 1"
                      >
                        <font-awesome-icon
                          :icon="stateFilterButtonCobrancas.iconFilterButton"
                          :style="{ color: stateFilterButtonCobrancas.color }"
                        />
                        {{ stateFilterButtonCobrancas.labelFilterButton }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="24"
                  style="
                    margin-top: 10%;
                    height: 12%;
                    display: flex;
                    flex-direction: row;
                    align-items: flex-end;
                  "
                >
                  <el-col :span="24" v-if="quantidadeCobrancas">
                    <el-tag
                      style="width: 100%; text-align: center; font-size: 15px"
                    >
                      <span>{{ labelQuantidadeCobrancasListadas }}</span>
                    </el-tag>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :md="24" :lg="16" :xl="16" style="height: 100%;">
              <el-row style="height: 100%">
                <div style="height: 98%; margin: -5px 0px 0px 0px;">
                  <el-col :span="24" style="height: 100%">
                    <el-table
                      :data="listaCobrancas"
                      stripe
                      empty-text="Nenhuma comunicação encontrada"
                      style="
                        background-color: #ffffff;
                        color: #1d1e1f;
                        font-size: 15px;
                      "
                      class="height-table"
                    >
                      <el-table-column>
                        <template slot-scope="scope">
                          <el-row
                            :gutter="24"
                            style="font-weight: bold; font-size: 16"
                          >
                            <el-col :span="14">
                              <div class="field-info">
                                <el-tooltip :content="labelCliente(scope.row)">
                                  <i
                                    class="el-icon-user-solid blue-icon-title"
                                  ></i>
                                </el-tooltip>
                                {{ scope.row.cliente.nome }}
                              </div>
                            </el-col>
                            <el-col :span="10">
                              <div style="margin-left: 12rem">
                                <el-button
                                  @click="removerCobrancaHandler(scope.row)"
                                  type="text"
                                  style="color: red; font-size: 12px"
                                  v-if="
                                    scope.row.tipo == 'COBRANCA_MANUAL' &&
                                    permissaoRemoverCobranca
                                  "
                                >
                                  Remover
                                </el-button>
                              </div>
                            </el-col>
                          </el-row>

                          <el-row
                            :gutter="24"
                            style="font-size: 13px; padding: 5px 0px 0px 0px"
                          >
                            <el-col :span="4">
                              <div class="field-info">
                                <el-tooltip :content="labelTootipComunicacao(scope.row)">
                                  <i :class="iconeComunicacao(scope.row)"></i>
                                </el-tooltip>
                                {{ labelId(scope.row) }}
                              </div>
                            </el-col>
                            <el-col :span="7">
                              <div class="field-info"
                                  style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                ">
                                <el-tooltip content="Canal">
                                  <i class="grey-icon">
                                    <font-awesome-icon icon="address-book" />
                                  </i>
                                </el-tooltip>
                                <el-tooltip :content="scope.row.cliente.email">
                                  <span>
                                    {{ getLabelCanal(scope.row) }}  
                                  </span>
                                                                                                    
                                </el-tooltip>
                              </div>
                            </el-col>
                            <el-col :span="2" v-if="exibirMesSerieVencimento(scope.row)">
                              <div class="field-info" >
                                <el-tooltip content="Mês Série">
                                  <i class="el-icon-files grey-icon"></i>
                                </el-tooltip>
                                {{ scope.row.recibo.mesSerie }}º
                              </div>
                            </el-col>

                            <el-col :span="4" v-if="exibirMesSerieVencimento(scope.row)">
                              <div class="field-info" >
                                <el-tooltip content="Vencimento">
                                  <i class="el-icon-date grey-icon"></i>
                                </el-tooltip>
                                {{ scope.row.recibo.dataVencimento }}
                              </div>
                            </el-col>

                            <el-col :span="exibirMesSerieVencimento(scope.row) ? 5 : 11" style="text-align: right;">
                              <div class="field-info">
                                <el-tooltip content="Data/Hora de Envio">
                                  <i class="grey-icon">
                                    <font-awesome-icon icon="calendar-check" />
                                  </i>
                                </el-tooltip>
                                {{ scope.row.dataHora }}
                              </div>
                            </el-col>

                          </el-row>
                          <el-row
                            :gutter="24"
                            style="font-size: 13px; padding: 0px 0px 15px 0px"
                          >
                            <el-col :span="4">
                              <div class="field-info">
                                <el-tooltip content="Tipo da Comunicação">
                                  <i class="grey-icon">
                                    <font-awesome-icon
                                      :icon="iconTipoCobranca(scope.row.tipo)"
                                    />
                                  </i>
                                </el-tooltip>
                                {{ getLabelTipo(scope.row.tipo) }}
                              </div>
                            </el-col>

                            <el-col :span="20" style="text-align: start;">
                              <div class="field-info">
                                <el-tooltip content="Descrição">
                                  <i
                                    class="el-icon-chat-dot-square grey-icon"
                                  ></i>
                                </el-tooltip>
                                {{
                                  scope.row.descricao
                                    ? scope.row.descricao
                                    : "Sem descrição"
                                }}
                              </div>
                            </el-col>
                          </el-row>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      layout="prev,pager,next"
                      background
                      style="margin-top: 10px"
                      @current-change="handleCurrentChange"
                      :page-size="100"
                      :total="quantidadeCobrancas"
                      :current-page.sync="currentPageCobrancas"
                      v-if="listaCobrancas.length > 0"
                    />
                  </el-col>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-main>

        <el-footer
          height="52px"
          style="background-color: #d1d1d1; padding: 10px 30px; display: none"
        >
          <el-row style="height: 100%">
            <el-col :span="24" style="height: 100%">
              <el-row type="flex" style="padding-top: 0px">
                <el-button @click="gerarRelatorio" type="success" size="small"
                  >Gerar Relatório</el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import URLS from "../util/urls.js";
import funcoes from "../util/funcoes";
import {
  TIPOS_COBRANCAS,
  CANAIS_COBRANCAS,
  TIPO_COBRANCA_AUTO,
  TIPOS_COMUNICACAO
} from "../util/constantes";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faSortAlphaDown,
  faSortNumericDown,
  faSortNumericUp,
  faStopCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faAddressBook,
  faCalendarCheck,
  faRobot,
  faHandPointer,
} from "@fortawesome/free-solid-svg-icons";
library.add(faSortAlphaDown, faSortNumericDown, faSortNumericUp, faStopCircle);
library.add(faAddressBook, faCalendarCheck, faRobot, faHandPointer);

export default {
  components: {
    FontAwesomeIcon,
  },

  data() {
    return {
      cobranca: {
        cliente: undefined,
        contrato: undefined,
        dataHoraInicial: funcoes.agora(true),
        dataHoraFinal: undefined,
        recibo: {
          dataVencimento: undefined,
        },
        email: undefined,
        tipo: "TODOS"
      },
      mesSerie: undefined,
      clientesDisponiveis: [],
      alugueisDisponiveis: [],
      listaCobrancas: [],

      quantidadeCobrancas: 0,
      loadingClientes: false,
      loadingAluguel: false,
      currentPageCobrancas: 1,

      //ORDENAÇÃO
      stateFilterButtonCobrancas: {
        labelFilterButton: "Sem Ordenação",
        iconFilterButton: "stop-circle",
        color: "#DF1B1B",
      },
      filtragemAtualCobrancas: "SEM_ORDENACAO",
    };
  },

  created() {
    this.pesquisa();
  },

  computed: {
    ...mapState("loginStore", {
      permissoes(state) {
        return state.usuarioLogado.permissoes.filter((permissao) => {
          return permissao.modulo === "CLIENTES_ALUGUEL";
        })[0];
      },
    }),

    tiposCobrancas() {
      return TIPOS_COBRANCAS;
    },

    canaisCobrancas() {
      return CANAIS_COBRANCAS;
    },
    tipoCobrancaAuto() {
      return TIPO_COBRANCA_AUTO;
    },
    tiposComunicacao(){
      return TIPOS_COMUNICACAO;
    },
    canalIsVisible() {
      return this.cobranca.tipo == "COBRANCA_MANUAL";
    },
    tipoCobrancaAutoIsVisible() {
      return this.cobranca.tipo == "COBRANCA_AUTOMATICA";
    },
    exibirOrdenacao(){
      return !(this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' 
      || this.cobranca.tipo === 'DESEMPENHO_IMOVEL');
    },
    exibirCampoCliente1(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_IPTU'
      );
    },
    exibirCampoEmail(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_IPTU'
      );
    },
    exibirCampoMesSerie(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO'
      );
    },
    exibirCampoVencimento(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO'
      );
    },
    exibirCampoDataRepasse(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' 
      );
    },
    exibirCampoData(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO'
      );
    },
    exibirCampoContrato(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_IPTU'
      );
    },
    exibirCampoCanal(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO'
      );
    },
    exibirCampoCliente(){
      return this.cobranca.tipo && (
        this.cobranca.tipo === 'ANIVERSARIO_PROPRIETARIO' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_ALUGUEL' ||
        this.cobranca.tipo === 'AVISO_PAGAMENTO_REPASSE' ||
        this.cobranca.tipo === 'AVISO_REAJUSTE' ||
        this.cobranca.tipo === 'AVISO_RENOVACAO' ||
        this.cobranca.tipo === 'COBRANCA_MANUAL' ||
        this.cobranca.tipo === 'AVISO_PREVIO' ||
        this.cobranca.tipo === 'AVISO_APOS_VENCIMENTO' ||
        this.cobranca.tipo === 'AVISO_NO_DIA_DO_VENCIMENTO'
      );
    },
    permissaoRemoverCobranca() {
      return this.permissoes.removerCobranca == true;
    },

    labelQuantidadeCobrancasListadas() {
      switch (this.quantidadeCobrancas) {
        case 1:
          return "1 comunicação encontrada";
        default:
          return `${this.quantidadeCobrancas} comunicações encontradas`;
      }
    },
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("loginStore", ["relogar"]),
    ...mapActions("alugueisClientesStore", ["pesquisarClientes"]),
    ...mapActions("alugueisContratosStore", ["listarAlugueis"]),

    //LABEL DE COBRANCAS
    exibirMesSerieVencimento(row){
      switch (row.tipoCobrancaAuto) {
        case 'ANIVERSARIO_PROPRIETARIO':
          return false;
        case 'ANIVERSARIO_LOCATARIO':
          return false;  
        case 'DESEMPENHO_IMOVEL':
          return false;
        case 'AVISO_REAJUSTE':
          return false;
        case 'AVISO_RENOVACAO':
          return false;
        case 'AVISO_IPTU':
          return false;        
        case 'PESQUISA_SATISFACAO':
          return false;   
        default: 
          return true;          
      }
    },
    labelCliente(row){
      switch (row.tipoCobrancaAuto) {
        case 'ANIVERSARIO_PROPRIETARIO':
          return "Aniversariante";
        case 'ANIVERSARIO_LOCATARIO':
          return "Aniversariante";  
        case 'DESEMPENHO_IMOVEL':
          return "Proprietário"
        default: 
          return "Cliente";          
      }
    },
    labelId(row){
      switch (row.tipoCobrancaAuto) {
        case 'ANIVERSARIO_PROPRIETARIO':
          return row.cliente.idNaImobiliaria;
        case 'ANIVERSARIO_LOCATARIO':
          return row.cliente.idNaImobiliaria;  
        case 'DESEMPENHO_IMOVEL':
          return row.imovel.idNaImobiliaria
        case 'AVISO_REAJUSTE':
          return row.aluguel.idNaImobiliaria;
        case 'AVISO_RENOVACAO':
          return row.aluguel.idNaImobiliaria;    
        default: 
          return row.recibo.aluguel.idNaImobiliaria;          
      }
    },
    iconeComunicacao(row){
      switch (row.tipoCobrancaAuto) {
        case 'ANIVERSARIO_PROPRIETARIO':
          return "el-icon-user-solid grey-icon"
        case 'ANIVERSARIO_LOCATARIO':
          return "el-icon-user-solid grey-icon"  
        case 'DESEMPENHO_IMOVEL':
          return "el-icon-school grey-icon"
        default: 
          return "el-icon-notebook-1 grey-icon";          
      }
    },
     labelTootipComunicacao(row){
      switch (row.tipoCobrancaAuto) {
        case 'ANIVERSARIO_PROPRIETARIO':
          return "ID do Proprietário"
        case 'ANIVERSARIO_LOCATARIO':
          return "ID do Locatário"  
        case 'DESEMPENHO_IMOVEL':
          return "ID do Imóvel"
        default: 
          return "ID do Contrato";          
      }
    },
    atualizarEstadoBotaoFiltroCobrancas() {
      switch (this.filtragemAtualCobrancas) {
        case "SEM_ORDENACAO":
          this.stateFilterButtonCobrancas = {
            labelFilterButton: "Sem Ordenação",
            iconFilterButton: "stop-circle",
            color: "#DF1B1B",
          };
          break;
        case "ALFABETICA":
          this.stateFilterButtonCobrancas = {
            labelFilterButton: "Ordem Alfabética",
            iconFilterButton: "sort-alpha-down",
            color: "#4B6EF6",
          };
          break;
        case "VENCIMENTO":
          this.stateFilterButtonCobrancas = {
            labelFilterButton: "Vencimento",
            iconFilterButton: "sort-numeric-down",
            color: "#4B6EF6",
          };
          break;
        case "MES_SERIE":
          this.stateFilterButtonCobrancas = {
            labelFilterButton: "Mes Série",
            iconFilterButton: "sort-numeric-down",
            color: "#4B6EF6",
          };
          break;
        default:
          break;
      }
    },

    limparOrdenacao() {
      this.stateFilterButtonCobrancas = {
        labelFilterButton: "Sem Ordenação",
        iconFilterButton: "stop-circle",
        color: "#DF1B1B",
      };
      this.filtragemAtualCobrancas = "SEM_ORDENACAO"
    },

    filtrarListaCobrancas() {
      switch (this.filtragemAtualCobrancas) {
        case "SEM_ORDENACAO":
          this.filtragemAtualCobrancas = "ALFABETICA";
          this.atualizarEstadoBotaoFiltroCobrancas();

          this.listaCobrancas.sort((itemA, itemB) => {
            if (itemA.cliente.nome < itemB.cliente.nome) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case "ALFABETICA":
          this.filtragemAtualCobrancas = "MES_SERIE";
          this.atualizarEstadoBotaoFiltroCobrancas();

          this.listaCobrancas.sort((itemA, itemB) => {
            if (itemA.recibo.mesSerie < itemB.recibo.mesSerie) {
              return -1;
            } else {
              true;
            }
          });
          break;
        case "MES_SERIE":
          this.filtragemAtualCobrancas = "VENCIMENTO";
          this.atualizarEstadoBotaoFiltroCobrancas();

          this.listaCobrancas.sort((itemA, itemB) => {
            return (
              funcoes.stringParaData(itemA.recibo.dataVencimento).getTime() -
              funcoes.stringParaData(itemB.recibo.dataVencimento).getTime()
            );
          });
          break;
        case "VENCIMENTO":
          this.filtragemAtualCobrancas = "SEM_ORDENACAO";
          this.atualizarEstadoBotaoFiltroCobrancas();

          this.listaCobrancas.sort((itemA, itemB) => {
            return (
              funcoes.stringParaData(itemA.recibo.dataVencimento).getTime() -
              funcoes.stringParaData(itemB.recibo.dataVencimento).getTime()
            );
          });
          break;
        default:
          break;
      }
    },

    montarPayload() {
      const payload = {
        cliente: this.cobranca.cliente,
        recibo: {
          aluguel: this.cobranca.contrato
            ? { id: this.cobranca.contrato.id }
            : undefined,
        },
        email: this.cobranca.email,
        dataHoraInicial: this.cobranca.dataHoraInicial,
        dataHoraFinal: this.cobranca.dataHoraFinal,
        tipo: this.cobranca.tipo,
        canal: this.cobranca.canal,
        canalOutros: this.cobranca.canalOutros,
        tipoCobrancaAuto: this.cobranca.tipoCobrancaAuto,
      };
      if (this.cobranca.recibo.dataVencimento) {
        payload.recibo.dataVencimento = this.cobranca.recibo.dataVencimento;
      }
      if (this.mesSerie && !this.cobranca.contrato) {
        payload.recibo = { mesSerie: this.mesSerie };
      } else if (this.mesSerie && this.cobranca.contrato) {
        payload.recibo.mesSerie = this.mesSerie;
      }

      if(this.cobranca.tipo === "TODOS"){
        delete payload.tipo
        delete payload.tipoCobrancaAuto
      }else if (this.cobranca.tipo == "COBRANCA_MANUAL") {
        payload.tipoCobrancaAuto = undefined;
      }else{
        payload.canal = undefined;
        payload.tipoCobrancaAuto = payload.tipo;
        payload.tipo = 'COBRANCA_AUTOMATICA';
      }

      return payload;
    },

    pesquisa() {
      const payload = this.montarPayload();

      this.showLoading();

      axios
        .post(URLS.CLIENTES_LISTAR_COBRANCAS, payload)
        .then((response) => {
          switch (response.data.status) {
            case "SUCESSO":
              this.listaCobrancas = response.data.lista;
              this.quantidadeCobrancas = response.data.quantidade;
              break;
            case "SESSAO_EXPIRADA":
              this.relogar().then((authResponse) => {
                if (authResponse.status == "SUCESSO") {
                  axios
                    .post(URLS.CLIENTES_LISTAR_COBRANCAS, payload)
                    .then((resposta) => {
                      if (resposta.data.status == "SUCESSO") {
                        this.listaCobrancas = resposta.data.lista;
                        this.quantidadeCobrancas = resposta.data.quantidade;
                      }
                    })
                    .catch((error) => {
                      throw error;
                    });
                }
              });
              break;
            case "ERRO":
              this.$message.error("Não foi possível conectar-se ao servidor");
          }
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          this.limparOrdenacao();
          this.hideLoading();
        });
    },

    removerCobrancaHandler(cobranca) {
      this.$confirm(
        "Deseja realmente remover essa cobrança do histórico?",
        "Atenção",
        {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning",
        }
      ).then(() => {
        this.removerCobranca(cobranca);
      });
    },

    removerCobranca(cobranca) {
      const payload = {
        id: cobranca.id,
        canal: cobranca.canal,
        canalOutros: cobranca.canalOutros,
        recibo: cobranca.recibo,
        cliente: cobranca.cliente,
      };

      this.showLoading();
      axios
        .post(URLS.COBRANCAS_REMOVER, payload)
        .then((response) => {
          switch (response.data.status) {
            case "SUCESSO":
              this.$message.success(response.data.mensagem);
              this.pesquisa();
              break;
            case "FALHA":
              this.$message.warning(response.data.mensagem);
              break;
            case "SESSAO_EXPIRADA":
              this.relogar().then((resultado) => {
                if (resultado.status == "SUCESSO") {
                  axios
                    .post(URLS.COBRANCAS_REMOVER, payload)
                    .then((response) => {
                      switch (response.data.status) {
                        case "SUCESSO":
                          this.$message.success(response.data.mensagem);
                          this.pesquisa();
                          break;
                        case "FALHA":
                          this.$message.warning(response.data.mensagem);
                          break;
                      }
                    })
                    .catch(() => {
                      this.hideLoading();
                    })
                    .finally(() => {
                      this.hideLoading();
                    });
                }
              });
          }
        })
        .catch(() => {
          this.hideLoading();
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    gerarRelatorio() {
      const cobranca = {
        cliente: this.cobranca.cliente,
        recibo: {
          aluguel: this.cobranca.contrato
            ? { id: this.cobranca.contrato.id,
                idNaImobiliaria: this.cobranca.contrato.idNaImobiliaria  
            }
            : undefined,
            
        },
        email: this.cobranca.email,
        dataHoraInicial: this.cobranca.dataHoraInicial,
        dataHoraFinal: this.cobranca.dataHoraFinal,
        tipo: this.cobranca.tipo,
        canal: this.cobranca.canal,
        canalOutros: this.cobranca.canalOutros,
        tipoCobrancaAuto: this.cobranca.tipoCobrancaAuto,
      };

      if (this.cobranca.recibo.dataVencimento) {
        cobranca.recibo.dataVencimento = this.cobranca.recibo.dataVencimento;
      }
      if (this.mesSerie && !this.cobranca.contrato) {
        cobranca.recibo = { mesSerie: this.mesSerie };
      } else if (this.mesSerie && this.cobranca.contrato) {
        cobranca.recibo.mesSerie = this.mesSerie;
      }

      if(this.cobranca.tipo === "TODOS"){
        delete cobranca.tipo
        delete cobranca.tipoCobrancaAuto
      }else if (this.cobranca.tipo == "COBRANCA_MANUAL") {
        cobranca.tipoCobrancaAuto = undefined;
      }else{
        cobranca.canal = undefined;
        cobranca.tipoCobrancaAuto = cobranca.tipo;
        cobranca.tipo = 'COBRANCA_AUTOMATICA';
      }

      const payload = {
        nome: "HISTORICO_COBRANCA",
        cobranca: cobranca,
      };

      this.showLoading();

      axios
        .post(URLS.RELATORIOS_GERAR, payload)
        .then((response) => {
          switch (response.data.status) {
            case "SUCESSO":
              window.open(response.data.mensagem, "_blank");
              break;
            case "SESSAO_EXPIRADA":
              this.relogar().then((authResponse) => {
                if (authResponse.status == "SUCESSO") {
                  axios
                    .post(URLS.RELATORIOS_GERAR, payload)
                    .then((resultado) => {
                      if (resultado.data.status == "SUCESSO") {
                        window.open(resultado.data.mensagem, "_blank");
                      }
                    })
                    .catch((error) => {
                      throw error;
                    });
                }
              });
              break;
            case "ERRO":
              this.$message.error("Não foi possível conectar-se ao servidor");
          }
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    getLabelTipo(tipo) {
      if (tipo === "COBRANCA_MANUAL") {
        return "Manual";
      } else {
        return "Automática";
      }
    },

    getLabelCanal(row) {
      return funcoes.getLabel(this.canaisCobrancas, row.canal) === "Email"
        ? "Email: " + row.cliente.email
        : funcoes.getLabel(this.canaisCobrancas, row.canal);
    },

    limparPesquisa() {
      this.cobranca = {
        cliente: undefined,
        contrato: undefined,
        dataHoraInicial: undefined,
        dataHoraFinal: undefined,
        recibo: {
          dataVencimento: undefined,
        },
        tipo: "TODOS"
      };
      this.mesSerie = undefined;
    },

    limparCobranca(){
      this.cobranca = {
        cliente: undefined,
        contrato: undefined,
        dataHoraInicial: funcoes.agora(true),
        dataHoraFinal: undefined,
        recibo: {
          dataVencimento: undefined,
        },
        tipo: this.cobranca.tipo
      };
      this.mesSerie = undefined;
    },

    filtrarClientesSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingClientes = true;
      this.pesquisarClientes(payload).then((resultado) => {
        this.clientesDisponiveis = resultado.lista;
        this.loadingClientes = false;
      });
    },

    filtrarAluguelSelect(queryString) {
      let payload = {
        idNaImobiliaria: queryString,
        locatario: {
          nome: this.cobranca.cliente ? this.cobranca.cliente.nome : undefined,
        },
      };
      this.loadingAluguel = true;
      this.listarAlugueis(payload).then((resultado) => {
        this.alugueisDisponiveis = resultado.lista;
        this.loadingAluguel = false;
      });
    },

    handleCurrentChange(pag) {
      const payloadMounted = this.montarPayload();

      const payload = {
        ...payloadMounted,
        pagina: pag - 1,
      };

      axios
        .post(URLS.CLIENTES_LISTAR_COBRANCAS, payload)
        .then((response) => {
          switch (response.data.status) {
            case "SUCESSO":
              this.listaCobrancas = response.data.lista;
              break;
            case "SESSAO_EXPIRADA":
              this.relogar().then((authResponse) => {
                if (authResponse.status == "SUCESSO") {
                  axios
                    .post(URLS.CLIENTES_LISTAR_COBRANCAS, payload)
                    .then((resposta) => {
                      if (resposta.data.status == "SUCESSO") {
                        this.listaCobrancas = resposta.data.lista;
                      }
                    })
                    .catch((error) => {
                      throw error;
                    });
                }
              });
              break;
            case "ERRO":
              this.$message.error("Não foi possível conectar-se ao servidor");
          }
        })
        .catch((error) => {
          throw error;
        });
    },

    iconTipoCobranca(item) {
      switch (item) {
        case "COBRANCA_MANUAL":
          return "hand-pointer";
        case "COBRANCA_AUTOMATICA":
          return "robot";
      }
    },
  },
};
</script>

<style scoped>
.field-info {
  margin: 1px 1px;
  text-overflow: ellipsis;
}
.blue-icon-title {
  color: #3a7297;
  font-size: large;
}
.grey-icon {
  color: grey;
  font-size: small;
}
.dont-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.height-table {
  height: 98%;
  overflow-y: visible;
}

@media screen and (max-height: 768px) {
  .height-table {
    max-height: 35em;
  }
}

@media screen and (max-height: 651px) {
  .height-table {
    max-height: 31em;
  }
}
</style>